// @flow
import AlertsContainer from './containers/AlertsContainer';

export default AlertsContainer;